import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

const styles = () => ({
  card: {
    marginBottom: 16,
    padding: 16,
    textAlign: 'center',
    color: '#394f5a',
  },
  rewardPointsWrapper: {
    float: 'left',
    lineHeight: 1,
    '& b': {
      fontSize: 18,
    },
    '& small': {
      fontSize: 10,
      textTransform: 'uppercase',
    },
  },
  rewardPointsInnerWrapper: {
    textAlign: 'center',
  },
  rewardImage: {
    maxWidth: '100%',
  },
  rewardPurchasedWrapper: {
    float: 'right',
    '& svg': {
      color: '#edf2f5',
    },
  },
  rewardPurchasedWrapperPurchased: {
    color: '#39843b',
    '& svg': {
      color: '#39843b',
    },
  },
  rewardStockInfo: {
    textAlign: 'center',
  },
  rewardWarningIcon: {
    color: 'orange',
    '& svg': {
      color: 'orange',
    },
    position: 'relative',
    textAlign: 'center',
    marginRight: '5px',
  },
  rewardWarningText: {
    color: 'orange',
    '& svg': {
      color: 'orange',
    },
    position: 'relative',
    textAlign: 'center',
    top: '-6px',
  },
  heading: {
    fontWeight: 'bold',
  },
  description: {
    color: '#7695a5',
    marginBottom: 20,
  },
  button: {
    backgroundColor: '#f56a12',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  textBlue: {
    color: '#2096f3',
  },
});

class RewardCard extends React.Component {
  render() {
    const {
      classes,
      t,
      reward,
      onPurchaseButtonClick,
    } = this.props;

    let rewardPurchasedWrapperClassName = classes.rewardPurchasedWrapper;
    if (reward.purchased) {
      rewardPurchasedWrapperClassName = `${classes.rewardPurchasedWrapper} ${classes.rewardPurchasedWrapperPurchased}`;
    }

    return (
      <div className="reward-card">
        <Paper
          elevation={1}
          key={reward.id}
          className={classes.card}
        >
          <Grid container>
            <Grid item xs={4}>
              <div className={classes.rewardPointsWrapper}>
                <div className={classes.rewardPointsInnerWrapper}>
                  <div><b>{reward.price}</b></div>
                  <div><small>{t('Points')}</small></div>
                </div>
              </div>
            </Grid>
            <Grid item xs={4}>
              <img
                className={classes.rewardImage}
                src={reward.photo}
              />
            </Grid>
            <Grid item xs={4}>
              <div className={rewardPurchasedWrapperClassName}>
                <div>
                  <CheckCircleIcon/>
                </div>
                {reward.purchased
                && (
                  <div>
                    <span>x</span>
                    {reward.purchased_count}
                  </div>
                )
                }
              </div>
            </Grid>
          </Grid>
          <Typography
            variant="h6"
            component="h4"
            className={classes.heading}
          >
            {reward.name}
          </Typography>
          <Typography
            component="p"
            className={classes.description}
          >
            {reward.description}
          </Typography>
          {reward.price_balance_difference > 0
          && (
            <Typography
              component="p"
              className={classes.description}
            >
              <span dangerouslySetInnerHTML={{
                // This is actual html and not jsx
                __html: t('You need {points_difference} more points')
                  .replace(
                    '{points_difference}',
                    `<b class="${classes.textBlue}">${reward.price_balance_difference}</b>`,
                  ),
              }}
              />
            </Typography>
          )
          }
          {(reward.stock <= 0 && reward.stock_control) && (
            <div className={classes.rewardStockInfo}>
              <WarningIcon className={classes.rewardWarningIcon}/>
              <span
                className={classes.rewardWarningText}>{reward.unable_to_purchase_reason}</span>
            </div>
          )}
          <Button
            variant="contained"
            onClick={onPurchaseButtonClick.bind(this, reward)}
            disabled={!reward.can_purchase}
            className={`purchase-button ${classes.button}`}
          >
            {t('Purchase')}
          </Button>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(RewardCard));
